import { createContext } from "react"
import { UseVirtualTable } from "./hooks"

const VirtualTableContext = createContext<UseVirtualTable>(null)

export default VirtualTableContext
